import { ProductDetails } from "@/@types";
import { transformProductImageGallery } from "@/helpers/products/transformProductImageGallery";
import GalleryImage from "@/components/ui/Gallery/GalleryImage";
import Link from "next/link";
import ProductGeneralSpec from "./ProductGeneralSpec";
import { ROUTES } from "@/config/routes";
import IconSprite from "@/components/common/IconSprite"
import QuotationButton from "./QuotationButton";

type ProductProps = {
  product: ProductDetails;
};

export default function ProductDetailsComponent({ product }: ProductProps) {

  if (!product) {
    return (
      <div>
        <p>No product available or invalid product slug.</p>
      </div>
    );
  }

  const images = transformProductImageGallery(product.contents.images);

  return (
    <div className="lg:container">
      <div className="flex flex-col lg:grid lg:grid-cols-[70%_30%] gap-4 lg:gap-0">
        <div className="relative lg:aspect-video border overflow-hidden">
          <GalleryImage
            imagesGallery={images}
            thumbnailWidth={150}
            thumbnailHeight={80}
            objectFit="cover"
          />
        </div>

        <div className="px-4 flex flex-col gap-2 bg-white mt-2 space-y-4">
          <div className="flex flex-col gap-2">
            <QuotationButton modalTitle={product.name} />
            {product.usedProduct?.length > 0 &&
              <Link href={product.usedProduct.length > 1 ? ROUTES.usedEquipments.root + `?query=${product.short_name}` : ROUTES.usedEquipments.used(product.usedProduct[0].slug)}
                className="relative flex items-center justify-between bg-light01 hover:bg-gray01 text-black py-4 px-4 text-lg w-full">
                MODELO DISPONIBLE EN SEMINUEVO
                <div className="absolute right-0 top-0 bottom-0 flex items-center px-4 bg-black/10">
                  <IconSprite id="ic_arrow_right_light" className="h-5 w-5" />
                </div>
              </Link>
            }
          </div>

          <div className="lg:max-h-[400px] overflow-y-auto space-y-4">
            <h2 className="text-lg font-bold text-gray-800 pt-1 ">
              ESPECIFICACIONES
            </h2>
            <ProductGeneralSpec
              generalSpecifications={product.general_specifications}
            />
            <h2 className="text-lg font-bold text-gray-800 py-0 lg:hidden xl:block">
              INFORMACIÓN GENERAL
            </h2>
            <div
              className="text-gray03 pb-1 lg:hidden xl:block "
              dangerouslySetInnerHTML={{ __html: product.short_description }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
